const RESERVE_BELOW = 60;
const RESIZE_DEBOUNCE_MS = 200;
const MEASURE_RETRIES = 10;

const scrolledAbove = element => {
  let offset = 0;
  for (let node = element.parentElement; node; node = node.parentElement) {
    offset += node.scrollTop;
  }
  return offset;
};

export default {
  data() {
    return {
      dynamicPageSize: 10,
      hasMeasuredPageSize: false,
    };
  },
  computed: {
    minTableRows() {
      return 4;
    },
  },
  mounted() {
    window.addEventListener('resize', this.onTablePageResize);
  },
  beforeDestroy() {
    this.tablePageGone = true;
    window.removeEventListener('resize', this.onTablePageResize);
    clearTimeout(this.tablePageResizeTimer);
  },
  methods: {
    syncTablePageSize(refetch) {
      this.tablePageRefetch = refetch;
      if (this.hasMeasuredPageSize) return;
      this.$nextTick(this.measureTablePageSize);
    },
    onTablePageResize() {
      clearTimeout(this.tablePageResizeTimer);
      this.tablePageResizeTimer = setTimeout(() => {
        this.hasMeasuredPageSize = false;
        this.tablePageRetries = MEASURE_RETRIES;
        this.measureTablePageSize();
      }, RESIZE_DEBOUNCE_MS);
    },
    retryTablePageMeasure() {
      if (!(this.tablePageRetries > 0)) return;
      this.tablePageRetries -= 1;
      this.tablePageResizeTimer = setTimeout(
        this.measureTablePageSize,
        RESIZE_DEBOUNCE_MS
      );
    },
    measureTablePageSize() {
      if (this.tablePageGone) return;
      if (this.hasMeasuredPageSize || !this.tablePageRefetch) return;
      const root = this.$el;
      if (!root || !root.querySelector) return;

      const headEl = root.querySelector('thead');
      const rowEl = root.querySelector('tbody tr');
      if (!headEl || !rowEl) {
        this.retryTablePageMeasure();
        return;
      }

      const rowHeight = Math.round(rowEl.getBoundingClientRect().height) || 52;
      const rowsTop =
        headEl.getBoundingClientRect().bottom + scrolledAbove(headEl);
      const available = window.innerHeight - rowsTop - RESERVE_BELOW;
      const fit = Math.max(
        this.minTableRows,
        Math.floor(available / rowHeight)
      );

      this.hasMeasuredPageSize = true;
      if (fit === this.dynamicPageSize) return;
      this.dynamicPageSize = fit;
      this.tablePageRefetch(fit);
    },
  },
};
